export default __webpack_public_path__ + "static/PMG_EGTB_HOHH_PDS_AGENCY_ENG-a5e109e1b0c0dab97153cf251519a599.pdf";